import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CRUD } from '../interfaces/crud.interface';
import { Count } from '../interfaces/count.interface';
import { CustomerSegmentsIface } from '../interfaces/customer-segments.iface';
import 'rxjs/add/operator/mergeMap';

@Injectable()
export class CustomerSegmentsService implements CRUD<CustomerSegmentsIface> {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.CUSTOMER_SEGMENTS_API_URL}`;
  }

  findAll(query: any, pageIndex: number, pageSize: number): Observable<CustomerSegmentsIface[]> {
    const queryParams = new HttpParams()
      .set('filter', JSON.stringify(query))
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<CustomerSegmentsIface[]>(`${this.url}/with-active-offers`, { params: queryParams });
  }

  findById(id: string): Observable<CustomerSegmentsIface> {
    return this.http.get<CustomerSegmentsIface>(`${this.url}/${id}`);
  }

  count(query: any): Observable<Count> {
    const queryParams = new HttpParams().set('filter', JSON.stringify(query));
    return this.http.get<Count>(`${this.url}/count`, { params: queryParams });
  }

  create(segment: CustomerSegmentsIface): Observable<CustomerSegmentsIface> {
    return this.http.post<CustomerSegmentsIface>(this.url, segment);
  }

  update(id: string, segment: CustomerSegmentsIface): Observable<CustomerSegmentsIface> {
    return this.http.put<CustomerSegmentsIface>(`${this.url}/${id}`, segment);
  }

  remove(id: string): Observable<CustomerSegmentsIface> {
    return this.http.delete<CustomerSegmentsIface>(`${this.url}/${id}`).mergeMap((response: any) => {
      return this.http.post<any>(`${environment.USER_GROUP_SEGMENT_URL}`, { id });
    });
  }

  getFile(filename: string): Observable<any> {
    return this.http.get<object>(`${this.url}/get-file?filename=${filename}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/customer-segments.service.ts